module.exports = __webpack_public_path__ + "static/media/logo_black.255a6791.svg";